import React from 'react';
import ReferencesLogs from '../ReferencesLogs';

const Bypass = () => {
  return <ReferencesLogs type="bypass" />;
};

export default Bypass;
